import { pageGroupKey } from '~/st-doc-viewer/page-groups/page-group-key'
import type { PageGroup } from '@st/sdk'
import type { DocumentViewerMessage } from '@st/document-viewer-kit'
import { PageGroupRows, PageGroupRow } from '@st/theme'
import { type ComponentProps } from 'react'
import { match } from '@st/pattern'

type RowContent = Omit<ComponentProps<typeof PageGroupRow>, 'title' | 'pageLabel' | 'onClickJump'>

/** Both workflows navigate the same page groups; only their row controls differ. */
export function PageGroupList({
  groups,
  sendViewerMessage,
  renderGroup
}: {
  groups: PageGroup[]
  sendViewerMessage: (message: DocumentViewerMessage) => void
  renderGroup: (group: PageGroup, index: number) => RowContent
}) {
  return (
    <PageGroupRows>
      {groups.map((group, index) => (
        <PageGroupRow
          key={pageGroupKey(group)}
          {...renderGroup(group, index)}
          title={group.title ?? ''}
          pageLabel={match(group.pageRange.first == group.pageRange.last)
            .with(true, () => `Page ${group.pageRange.first}`)
            .with(false, () => `Pages ${group.pageRange.first}–${group.pageRange.last}`)
            .exhaustive()}
          onClickJump={() =>
            sendViewerMessage({
              type: 'requestViewerScroll',
              target: { pageNumber: group.pageRange.first },
              behavior: 'smooth'
            })
          }
        />
      ))}
    </PageGroupRows>
  )
}
